module.exports = __webpack_public_path__ + "img/a6efaec87f7d0f12e367afc54adca49e-enable_2fa_2.png";